/**
 * Static application settings configuration.
 * These settings control various application behaviors and defaults.
 */
export const CONFIG = {
  admin: {
    tables: {
      rowsCount: 10
    }
  },
  i18n: {
    supportedLanguages: [
      'pl',
      'en',
      // 'de',
      // 'fr',
      // 'it'
    ],
    defaultLanguage: 'pl'
  }
} as const;

